



























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetPatientInfo, GetPatientPartDetail } from "@/request/hdr";
import DetailHeader from "./detail-header.vue";
import DetailLeftNav from "./detail-left-nav.vue";
import Gerenxinxi from "./details/gerenxinxi.vue";
import Jiankangshi from "./details/jiankangshi.vue";
import Zhongyitizhi from "./details/zhongyitizhi.vue";
import Sizhenhecan from "./details/sizhenhecan.vue";
import Ertong from "./details/ertong.vue";
import Laonian from "./details/laonian.vue";
import Beiyun from "./details/beiyun.vue";
import Yunqi from "./details/yunqi.vue";
import Chanhou from "./details/chanhou.vue";
import Weijuejing from "./details/weijuejing.vue";
import Gaoxueya from "./details/gaoxueya.vue";
import Tangniaobing from "./details/tangniaobing.vue";
import Xinliceping from "./details/xinliceping.vue";
// import Tongue from "@/components/tongueFacePluse/tongue-basis.vue";
import Shexiang from "../../../idr/views/patient-detail/details/shexiang-keyan/shexiang-keyan.vue";
import Mianxiang from "../../../idr/views/patient-detail/details/mianxiang/mianxiang.vue";
import Maixiang from "../../../idr/views/patient-detail/details/maixiang/maixiang.vue";
@Component({
  components: {
    DetailHeader,
    DetailLeftNav,
    Gerenxinxi,
    Jiankangshi,
    Zhongyitizhi,
    Sizhenhecan,
    Ertong,
    Laonian,
    Beiyun,
    Yunqi,
    Chanhou,
    Weijuejing,
    Gaoxueya,
    Tangniaobing,
    Xinliceping,
    // Tongue,
    Shexiang,
    Mianxiang,
    Maixiang,
  },
})
export default class HdrPatientDetail extends Vue {
  private patient: any = {};
  private cState: any = "个人信息";
  private message: any = {};
  private loaded: boolean = false;
  @Watch("$route.query", { immediate: true })
  private queryChange(query: any) {
    if (query.patient_id && query.part) {
      this.cState = query.part;
      if (this.cState === "健康史") {
        this.$set(this.message, "既往病史", []);
      }
      this.patient.patient_id = query.patient_id;
      this.fetchPatientPartDetail();
    }
  }
  /**
   * @description 获得患者基本信息
   */
  private fetchPatient() {
    GetPatientInfo(this, this.patient.patient_id).then((data: any) => {
      this.patient = data;
    });
  }

  /**
   * @description 获得患者某部分信息
   */
  private fetchPatientPartDetail() {
    this.loaded = false;
    if (
      this.cState === "舌象数据-科研版" ||
      this.cState === "面象数据" ||
      this.cState === "脉象数据"
    ) {
      let arg: string = "";
      switch (this.cState) {
        case "舌象数据-科研版":
          arg = "舌象科研";
          break;
        default:
          arg = this.cState;
      }
      GetPatientPartDetail(this, this.patient.patient_id, arg).then(
        (data: any) => {
          this.message = data;
          this.loaded = true;
        }
      );
    } else {
      GetPatientPartDetail(this, this.patient.patient_id, this.cState).then(
        (data: any) => {
          this.message = data;
          this.loaded = true;
        }
      );
    }
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.patient.patient_id = this.$route.query.patient_id;
    this.cState = this.$route.query.part ? this.$route.query.part : "个人信息";
    this.fetchPatient();
    this.fetchPatientPartDetail();
  }
}
